import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { AuthenticationService } from './authentication.service';
import { CredentialService } from './credential.service';

import { ORDER_SHIPMENT_REPORT, ORDER_COMPLETION_RATE_REPORT, FINISHING_EQUIPMENT_REPORT, CUSTOMER_SERVICE_REPORT, ORDERS_REPORT, COMPLAINT_REPORT, EOM_REPORT } from './../../ngrx/report-charts';
import { Store } from '@ngrx/store';
import { REPRINT } from 'ngrx/status-types';

const errorCodes = [400, 401, 403, 404];

@Injectable()
export class ReportService {
  constructor(
    private authService: AuthenticationService,
    private credentialService: CredentialService,
    private store            : Store<any>
  ) {}

  private invokeReportRequest(payload: any): Observable<any> {
    return new Observable(observer => {

      this.credentialService.lambda.invoke({
        FunctionName: environment.reportRequestFunction,
        Payload: JSON.stringify(payload)
        }, (err, data) => {
          if (err) {
            if (errorCodes.find(code => code === err.statusCode) && localStorage.getItem('currentUser')) {
              this.authService.refreshCredentials();
              // this.authService.logout();
            }
            observer.error(err);
          } else {
            const output = typeof data.Payload === 'string'
              ? JSON.parse(data.Payload)
              : data.Payload;
            observer.next(output);
          }
        }
      );
    });
  }

  private invokeMaterialUsageReport(payload: any): Observable<any> {
    return new Observable(observer => {

      this.credentialService.lambda.invoke({
        FunctionName: environment.materialUsageRequestFunction,
        Payload: JSON.stringify(payload)
        }, (err, data) => {
          if (err) {
            if (errorCodes.find(code => code === err.statusCode) && localStorage.getItem('currentUser')) {
              this.authService.refreshCredentials();
              // this.authService.logout();
            }
            observer.error(err);
          } else {
            const output = typeof data.Payload === 'string'
              ? JSON.parse(data.Payload)
              : data.Payload;
            observer.next(output);
          }
        }
      );
    });
  }

  getReportListView(): Observable<any> {
    return this.store.select('reports', 'reportListView');
  }
  
  generateOrderReport(from: string, to: string, process)  {
    const payload = {
      report: ORDER_SHIPMENT_REPORT, from, to, category: process
    }
    console.log("gernateOrderReport Payload : ", payload)
    return this.invokeReportRequest(payload);
  }

  generateReprintReport(from: Number, to: Number, process) {
    const payload = {
      report: REPRINT, from, to, category: process
    }
    console.log("generateReprintReport Payload : ", payload)
    return this.invokeReportRequest(payload);
  }

  generateCompletionReport(dueDate: string, process) {
    const payload = {
      report: ORDER_COMPLETION_RATE_REPORT, dueDate, category: process
    }
    console.log("generateCompletionReport Payload : ", payload)
    return this.invokeReportRequest(payload);
  }

  generateEquipmentUtilReport(from: string, to: string, process) {
    const payload= {
      report: FINISHING_EQUIPMENT_REPORT, from, to, category: process
    }
    console.log("generateEquipmentUtilReport Payload : ",payload);
    return this.invokeReportRequest(payload);
  }

  generateCustomerServiceReport(from: string, to: string, process)  {
    const payload = {
      report: CUSTOMER_SERVICE_REPORT, from, to, category: process
    }
    console.log("generateCustomerServiceReport Payload : ", payload)
    return this.invokeReportRequest(payload);
  }

  generateOrdersReport(from: Number, to: Number, process) {
    const payload = {
      report: ORDERS_REPORT, from, to, category: process
    }
    console.log("generateOrdersReport Payload : ", payload)
    return this.invokeReportRequest(payload);
  }

  generateComplaintReport(from: Number, to: Number, process)  {
    const payload = {
      report: COMPLAINT_REPORT, from, to, category: process
    }
    console.log("generateComplaintReport Payload : ", payload)
    return this.invokeReportRequest(payload);

  }
  generateMaterialUsageReport(from: Number, to: Number, process, subassemblies: any[])  {
    const payload = {
      from, to, category: process, subassemblies
    }
    console.log("generateMaterialUsageReport Payload : ", payload)
    return this.invokeMaterialUsageReport(payload);
  }
  generateEOMReport(from: Number, to: Number) {
    const payload = {
      report: EOM_REPORT, from, to
    }
    // console.log("generateEOMReport Payload : ", payload)
    return this.invokeReportRequest(payload);
  }
}



// WEBPACK FOOTER //
// /Users/jlam2/impresocloud/www/client/src/app/services/report.service.ts